/*
  THIS FILE IS GENERATED !!

  #> npm run gen:people
*/
/* eslint-disable */

export default {
  "Amber Ward": {
    "title": "Amber Ward",
    "position": "UX Researcher and Project Manager",
    "thumbSrc": "/static/content/uploads/amberward.jpg"
  },
  "Annika Hansteen-Izora": {
    "title": "Annika Hansteen-Izora",
    "position": "UX Researcher",
    "thumbSrc": "/static/content/uploads/annika-hansteen-izora.jpg"
  },
  "Ben Decherd": {
    "title": "Ben Decherd",
    "position": "UX Researcher",
    "thumbSrc": "/static/content/uploads/ben1.jpg"
  },
  "Crystal Rutland": {
    "title": "Crystal Rutland",
    "position": "Founder and CEO",
    "thumbSrc": "/static/content/uploads/people-crystal-rutland-1200.jpg"
  },
  "David McCuskey": {
    "title": "David McCuskey",
    "position": "Director of Technology",
    "thumbSrc": "/static/content/uploads/thumb-david-mccuskey.png"
  },
  "Emma Shepanek": {
    "title": "Emma Shepanek",
    "position": "UX Researcher ",
    "thumbSrc": "/static/content/uploads/people-emma-shepanek-240.png"
  },
  "Joe Smith ": {
    "title": "Joe Smith ",
    "position": "Best UX Researcher EVER ",
    "thumbSrc": "/static/content/uploads/thumb-person.png"
  },
  "Jon Salud": {
    "title": "Jon Salud",
    "position": "UX Researcher and Designer",
    "thumbSrc": "/static/content/uploads/jon2.jpg"
  },
  "Kat Sutton": {
    "title": "Kat Sutton",
    "position": "UX and Visual Designer",
    "thumbSrc": "/static/content/uploads/kat1.jpg"
  },
  "Matt Adamo": {
    "title": "Matt Adamo",
    "position": "Director of UX Strategy",
    "thumbSrc": "/static/content/uploads/matt.jpg"
  },
  "Stacey Rutland": {
    "title": "Stacey Rutland",
    "position": "Director of Client Services",
    "thumbSrc": "/static/content/uploads/stacey.jpg"
  },
  "Zak Edey": {
    "title": "Zak Edey",
    "position": "UX Designer",
    "thumbSrc": "/static/content/uploads/zak.jpg"
  }
};



// WEBPACK FOOTER //
// ./src/content/people-index.js